<div id="tv_chart_container" class="pb-sm-0 pb-3" [ngStyle]="{ height: isPairAvailable ? '440px' : '0px' }"></div>

<ng-container *ngIf="!isPairAvailable">
    <div class="error-container">
        <div>{{ 'COIN.CHART.ERROR.PAIR_NOT_FOUND' | translate }}</div>
        <div>{{ 'COIN.CHART.ERROR.SEE_OTHER_COINS' | translate }}</div>
    </div>
</ng-container>
